import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiUrls } from '../../../../config/api-urls/api-urls';
import { MainService } from '../../../../provider/main.service';
declare var $: any;
declare var jQuery: any;

@Component({
  standalone: false,
  selector: 'app-add-therapist',
  templateUrl: './add-therapist.component.html',
  styleUrls: ['./add-therapist.component.css']
})
export class AddTherapistComponent implements OnInit {

  addTherapistForm: FormGroup | any;
  file: any;
  imageType: any;
  imageUrl: any;
  countryArr: any = [];
  selectedTherapy: any = 'THERAPIST';
  week: any = [];
  programList: any = [];
  today: string = '';
  eventChecked: boolean = false;
  weekIndex: number = 0;
  Sunday = {
    week: 'Sunday',
    checked: false
  };
  Monday = {
    week: 'Monday',
    checked: false
  };
  Tuesday = {
    week: 'Tuesday',
    checked: false
  };
  Wednesday = {
    week: 'Wednesday',
    checked: false
  };
  Thursday = {
    week: 'Thursday',
    checked: false
  };
  Friday = {
    week: 'Friday',
    checked: false
  };
  Saturday = {
    week: 'Saturday',
    checked: false
  };
  selectedWeekStatus: any = [];
  expanded: boolean = false;
  assignedProgram: any = [];
  constructor(public service: MainService, private router: Router) { }

  ngOnInit() {
    this.addTherapistFormValidation();
    this.getCountryCodeData();
    this.viewProgramList();
    jQuery.fn.multiselect = function () {
      var $that = $(this);
      $that.each(function () {
        var checkboxes = $that.find("input:checkbox");
        checkboxes.each(function () {
          var checkbox = $that;
          // Highlight pre-selected checkboxes
          if (checkbox.prop("checked"))
            checkbox.parent().addClass("multiselect-on");

          // Highlight checkboxes that the user selects
          checkbox.click(function () {
            if (checkbox.prop("checked"))
              checkbox.parent().addClass("multiselect-on");
            else
              checkbox.parent().removeClass("multiselect-on");
          });
        });
      });
    };
    $(() => {
      $(".multiselect").multiselect();
    })

  }

  programChange(event: any, id: any) {
    if (event === true) {
      this.assignedProgram.push(id);
    }
    else {
      if ((event === false) && this.assignedProgram.length > 0) {
        let index = this.assignedProgram.findIndex((x: any) => x == id)
        this.assignedProgram.splice(index, 1);
      }
    }
  }

  weekChange(event: any, week: any) {
    if (event === true) {
      this.week.push(week);
      this.selectedWeekStatus.push({ "week": week, "checked": event });
    }
    else {
      if ((event === false) && this.week.length > 0) {
        this.weekIndex = this.week.findIndex((x: any) => x == week)
        this.week.splice(this.weekIndex, 1);
        this.selectedWeekStatus.splice(this.weekIndex, 1);
      }
    }
    this.eventChecked = event;
    let Sunday = this.selectedWeekStatus.find((x: any) => (x.week == 'Sunday') && (x.checked == true));
    if (Sunday == undefined) {
      this.Sunday = {
        week: 'Sunday',
        checked: false
      };
    }
    else {
      this.Sunday = Sunday
    }
    let Monday = this.selectedWeekStatus.find((x: any) => (x.week == 'Monday') && (x.checked == true));
    if (Monday == undefined) {
      this.Monday = {
        week: 'Monday',
        checked: false
      };
    }
    else {
      this.Monday = Monday
    }
    let Tuesday = this.selectedWeekStatus.find((x: any) => (x.week == 'Tuesday') && (x.checked == true));
    if (Tuesday == undefined) {
      this.Tuesday = {
        week: 'Tuesday',
        checked: false
      };
    } else {
      this.Tuesday = Tuesday
    }
    let Wednesday = this.selectedWeekStatus.find((x: any) => (x.week == 'Wednesday') && (x.checked == true));
    if (Wednesday == undefined) {
      this.Wednesday = {
        week: 'Wednesday',
        checked: false
      };
    } else {
      this.Wednesday = Wednesday
    }
    let Thursday = this.selectedWeekStatus.find((x: any) => (x.week == 'Thursday') && (x.checked == true));
    if (Thursday == undefined) {
      this.Thursday = {
        week: 'Thursday',
        checked: false
      };
    } else {
      this.Thursday = Thursday
    }
    let Friday = this.selectedWeekStatus.find((x: any) => (x.week == 'Friday') && (x.checked == true));
    if (Friday == undefined) {
      this.Friday = {
        week: 'Friday',
        checked: false
      };
    } else {
      this.Friday = Friday
    }

    let Saturday = this.selectedWeekStatus.find((x: any) => (x.week == 'Saturday') && (x.checked == true));
    if (Saturday == undefined) {
      this.Saturday = {
        week: 'Saturday',
        checked: false
      };
    } else {
      this.Saturday = Saturday
    }
  }



  ValidateFileUpload(event: any) {
    this.file = event.target.files;
    if (this.file[0]) {
      this.imageType = this.file[0].type;
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.imageUrl = e.target.result;
        this.uploadImage()
      };
      reader.readAsDataURL(this.file[0]);
    }
  }

  // upload Image api integration 
  uploadImage() {
    const data: FormData = new FormData();
    data.append('image', this.file[0])
    this.service.postApi(ApiUrls.uploadImage, data, 3).subscribe((res) => {
      if (res.responseCode == 200) {
        this.imageUrl = res.result.image
      }
    })
  }

  // program list api inntegration 
  viewProgramList() {
    this.service.getApi(ApiUrls.programList, 1).subscribe((res) => {
      if (res.responseCode == 200) {
        this.programList = res.result;
      }
      else {
        this.service.errorToast(res.responseMessage)
      }
    }, err => {
      this.service.errorToast(err.responseMessage)
    })
  }
  // Add Subadmin Form Validation

  addTherapistFormValidation() {
    this.addTherapistForm = new FormGroup({
      //  'programId' : new FormControl('',Validators.required),
      'address': new FormControl('', Validators.required),
      'timeZone': new FormControl('0', Validators.required),
      'speciality': new FormControl('ENGLISH', Validators.required),
      'degree': new FormControl('', Validators.required),
      'conPassword': new FormControl(''),
      'password': new FormControl('', Validators.required),
      'startDate': new FormControl('', Validators.required),
      'endDate': new FormControl('', Validators.required),
      'interval': new FormControl('', Validators.required),
      'institution': new FormControl('', Validators.required),
      'phoneCode': new FormControl('+1', Validators.required),
      'startHourTime': new FormControl('', Validators.required),
      'endHourTime': new FormControl('', Validators.required),
      'firstName': new FormControl('', Validators.compose([Validators.required, Validators.maxLength(62), Validators.pattern(/^[^\s][a-zA-Z ]*$/)])),
      'lastName': new FormControl(''),
      "email": new FormControl('', ([Validators.required, Validators.pattern(/^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/i), Validators.maxLength(50)])),
      "phoneNumber": new FormControl('', ([Validators.required, Validators.pattern(/^[1-9][0-9]{9,13}$/)])),
    });
    this.addTherapistForm.valueChanges.subscribe();
  }

  // Search by Date
  searchByDate() {
    if (this.addTherapistForm.value.startHourTime > this.addTherapistForm.value.endHourTime) {
      this.service.errorToast('Start time should be less than end time')
      // this.addTherapistForm.value.fromDate = '';
      // this.messege = "please enter right date"
    }
    //   else if(this.addTherapistForm.value.fromDate <= this.addTherapistForm.value.toDate){
    //  this.oldDate = new Date(this.form.value.fromDate).toISOString()
    //     this.newDate = new Date(this.form.value.toDate+'T23:59:59.999Z')
    //   })
    // }
  }

  // TO add therapist api integration 
  addTherapist() {
    if (this.addTherapistForm.value.startDate > this.addTherapistForm.value.endDate) {
      this.service.errorToast('Start Date should be less than end Date');
      return
    }
    if (this.week.length == 0) {
      this.service.errorToast('Please select week days');
      return
    }
    if (this.assignedProgram.length == 0) {
      this.service.errorToast('Please select program');
      return
    }
    if (this.addTherapistForm.value.startHourTime.split(':')[0] > this.addTherapistForm.value.endHourTime.split(':')[0]) {
      this.service.errorToast('Start time should be less than end time');
      return
    }

    const data = {
      assignedPrograms: this.assignedProgram,
      role: this.selectedTherapy,
      firstName: this.addTherapistForm.value.firstName,
      lastName: this.addTherapistForm.value.lastName,
      email: this.addTherapistForm.value.email,
      countryCode: this.addTherapistForm.value.phoneCode,
      mobileNumber: this.addTherapistForm.value.phoneNumber,
      profilePic: this.imageUrl,
      speciality: this.addTherapistForm.value.speciality,
      degree: this.addTherapistForm.value.degree,
      institution: this.addTherapistForm.value.institution,
      offSet: this.addTherapistForm.value.timeZone,
      address: this.addTherapistForm.value.address,
      password: this.addTherapistForm.value.password,
      startDate: this.addTherapistForm.value.startDate,
      endDate: this.addTherapistForm.value.endDate,
      weekDays: this.week,
      interval: Number(this.addTherapistForm.value.interval),
      startHour: this.addTherapistForm.value.startHourTime.split(':')[0],
      startMinute: this.addTherapistForm.value.startHourTime.split(':')[1],
      endHour: this.addTherapistForm.value.endHourTime.split(':')[0],
      endMinute: this.addTherapistForm.value.endHourTime.split(':')[1],
    }
    this.service.showSpinner()
    this.service.postApi(ApiUrls.addTherapist, data, 1).subscribe((res) => {
      this.service.hideSpinner();
      if (res.responseCode == 200) {
        this.service.successToast(res.responseMessage);
        this.router.navigate(['therapist'])
      }
      else {
        this.service.errorToast(res.responseMessage)
      }
    });
  }

  // Block special character from name
  inputkeyPress(e: any) {
    var k
    if (e.charCode == 32 && !e.target.value) {
      e.preventDefault()
    }
    else {
      document.all ? k = e.keyCode : k = e.which;
      return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32);
    }
  }
  //Allow only numbers
  inputKeyPress(e: any) {
    var k
    if (e.charCode == 32 && !e.target.value) {
      e.preventDefault()
    }
    else {
      document.all ? k = e.keyCode : k = e.which;
      return ((k > 47 && k < 58) || k == 8);
    }
  }

  //For password keypres
  passwordKeyPress(e: any) {
    if (e.charCode == 32 && !e.target.value) {
      e.preventDefault()
    }
  }

  getCountryCodeData() {
    this.service.getCountryCode().subscribe((res) => {
      this.countryArr = res
    })
  }

  onImageError(event: any) {
    event.target.src = 'https://res.cloudinary.com/smsit/image/upload/v1597335652/fmcvdi2g6ogd5vwzvzfa.jpg';
  }
}
